import {
    GET_SIZE_ERROR,
    GET_SIZE_REQUEST,
    GET_SIZE_SUCCESS,
    ADD_SIZE_ERROR,
    ADD_SIZE_REQUEST,
    ADD_SIZE_SUCCESS,
    DELETE_SIZE_REQUEST,
    DELETE_SIZE_SUCCESS,
    DELETE_SIZE_ERROR,
    UPDATE_SIZE_ERROR,
    UPDATE_SIZE_REQUEST,
    UPDATE_SIZE_SUCCESS,
} from "./types";

import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const getSize = (token, menu_id) => (dispatch, getState) => {
    const { size } = getState();
    // if data is present in store return promise resolved
    if (size?.payload?.data?.length) {
        return Promise.resolve();
    }
    // if data is not present in store then fetch from server
    dispatch({ type: GET_SIZE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/size`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { menu_id }
    })
        .then((response) => {
            return dispatch({ type: GET_SIZE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_SIZE_ERROR,
                payload: error.response,
            });
        });
};

export const addSize = (token, data, menu_id) => (dispatch) => {
    dispatch({ type: ADD_SIZE_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}create/size`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { size_name: data.sizeName, is_active: data.check, menu_id },
    })
        .then((response) => {
            return dispatch({ type: ADD_SIZE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_SIZE_ERROR,
                payload: error.response,
            });
        });
};
export const updateSize = (token, data, id) => (dispatch) => {
    dispatch({ type: UPDATE_SIZE_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/size/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { size_name: data.sizeName, is_active: data.check },
    })
        .then((response) => {
            return dispatch({ type: UPDATE_SIZE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_SIZE_ERROR,
                payload: error.response,
            });
        });
};

export const deleteSize = (token, id) => (dispatch) => {
    dispatch({ type: DELETE_SIZE_REQUEST });
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/size/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({ type: DELETE_SIZE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_SIZE_ERROR,
                payload: error.response,
            });
        });
};
